export default __webpack_public_path__ + "static/media/ModalImage11.83bee885.PNG";